import { render } from "./ErrorSection.vue?vue&type=template&id=6005c712&scoped=true"
const script = {}

import "./ErrorSection.vue?vue&type=style&index=0&id=6005c712&scoped=true&lang=css"

import exportComponent from "/mnt/data/workspace/risetai/riset.ai-website/Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6005c712"]])

export default __exports__